import { render } from "./ProfilesGate.vue?vue&type=template&id=1ae23d06&scoped=true"
import script from "./ProfilesGate.vue?vue&type=script&lang=js"
export * from "./ProfilesGate.vue?vue&type=script&lang=js"

import "./ProfilesGate.vue?vue&type=style&index=0&id=1ae23d06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae23d06"]])

export default __exports__